module.exports = __webpack_public_path__ + "img/hatchet-gold.dfae9be7.svg";